<rav-new-button *ngIf="!router.url.includes('/admin')" [isSidebarCollapsed]="isSidebarCollapsed"></rav-new-button>
<ul
  *ngFor="let menu of menus; let last = last"
  class="vertical menu | sidebar__menu"
  data-cy="sidebar-menu"
  [class.cursor__move]="
    dragDrop.isDragging &&
    dragDrop.target &&
    (dragDrop.target.region === DragDropRegion.FolderMenuNode ||
      dragDrop.target.region === DragDropRegion.OtherSidebarMenu)
  "
>
  <ng-container *ngFor="let item of menu">
    <li
      class="sidebar__item"
      [ngClass]="{ 'item-active': isFoldersActive(item.name) }"
      *ngIf="scope.hasAccesses(item.scope) && !item.isHidden"
    >
      <a
        *ngIf="item.name === 'Folders' ? mobile.isMobileDisplay() : true"
        [routerLink]="item.uri"
        routerLinkActive="is-active"
        #rla="routerLinkActive"
        class="align-middle sidebar__link"
        (mouseenter)="dragEnter(item)"
        (mouseleave)="dragDrop.target = undefined"
      >
        <div class="grid-x" [attr.data-cy]="'menu-item-' + item.name">
          <rav-icon
            [title]="item.name"
            [name]="rla.isActive ? item.iconActive : item.icon"
            class="cell sidebar__icon"
          ></rav-icon>
          <span class="cell auto align-self-middle sidebar__item-text">{{ item.name }} </span>
          <span *ngIf="item.notification | async" class="cell shrink sidebar__notification">
            <span data-cy="inbox-notification" class="round secondary label">{{ item.notification | async }}</span>
          </span>
        </div>
      </a>

      <rav-folder-menu
        *ngIf="item.name === 'Folders'"
        [isFolderSelect]="false"
        class="show-for-medium"
      ></rav-folder-menu>
    </li>
  </ng-container>
</ul>

<rav-account-info class="hide-for-medium" *ngIf="mobile.isMobileDisplay()"></rav-account-info>
